<template>
	<li :class="['draggable-list__item', disabled && 'is-disabled']">
		<div :class="['draggable-item', isDraggableMode ? 'is-editing' : '']">
			<div class="draggable-item__header" v-if="isPrimary">
				<slot name="header" />
			</div>
			<div class="draggable-item__body" data-testid="draggable-list-item">
				<span
					:class="[
						'draggable-item__icon',
						isGrabbing && 'is-grabbing'
					]"
					@mousedown="isGrabbing = true"
					@mouseup="isGrabbing = false"
					@mouseleave="isGrabbing = false"
				>
					<i class="icon icon-grab" />
				</span>
				<slot name="content" />
			</div>
			<div class="draggable-item__footer" v-if="$slots.footer">
				<slot name="footer" />
			</div>
		</div>
	</li>
</template>

<script>
export default {
	name: 'DraggableList',
	props: {
		isDraggableMode: {
			type: Boolean
		},
		isPrimary: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isGrabbing: false
		};
	}
};
</script>

<style lang="scss" scoped>
.draggable-item {
	border: $form-input-border;
	background: $white;
	border-radius: $form-border-radius;
	position: relative;

	&__header {
		width: 100%;
		display: block;
		background-color: $base;

		font-size: 14px;
		padding: $padding-sm;
		font-weight: $medium-font-weight;
		color: $white;
	}

	&__body {
		display: grid;
		grid-template-columns: 32px calc(100% - 32px);
		width: 100%;
		padding: $padding-md;
	}

	&__icon {
		display: inline-flex;
		align-items: center;
		padding-right: $padding-md;
		font-size: 22px;
		cursor: grab;

		&.is-grabbing {
			cursor: grabbing;
		}
	}

	&.is-editing {
		> .draggable-item__body {
			grid-template-columns: auto;
		}

		.draggable-item__icon {
			display: none;
		}
	}
}

.is-ghost {
	.draggable-item {
		&:before {
			content: '';
			background: $neutral-4;
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
			display: block;
			z-index: 20;
			border-radius: $border-radius;
			opacity: 0.8;
		}
	}
}

.is-sortable-chosen {
	.draggable-item {
		border: 2px solid $base;
		background-color: $white;
		opacity: 1;
	}
}
</style>
